// extracted by mini-css-extract-plugin
export default {"wrap":"PatientGeneralInfo_wrap__CxXw6","personal-info-title":"PatientGeneralInfo_personal-info-title__-F203","submit":"PatientGeneralInfo_submit__qvS1S"};